// Document ready
$(function(){


    /*user downloads data capture*/
    var userDataModal = $('#user-data-modal');
    $('a.report-me').on('click',function(e){
        e.preventDefault();
        // fire a request to see if we have information on the user
        var filename = '';
        if($(e.currentTarget).text()){
            filename = $(e.currentTarget).text();
        }else{
            filename = $(e.target).attr('alt');
        }
        ajaxCallUserData($(e.currentTarget).attr('href'), filename, Cookies.get('robinson_fans_download_cookie'));
    });

    $(document).keydown(function(e) {
        // if cmd/ctrl + shift + x is pressed check to see if unset php cookie
        if ((e.metaKey == true || e.ctrlKey == true) && e.shiftKey == true && e.keyCode == 88) {
            Cookies.remove('robinson_fans_download_cookie');
            console.log('robfan cookie tracking info deleted');
        }
    });

    function ajaxCallUserData( downloadURL, requestedFilename, cookie, postData ){
        var formURL = '/capture/userform.php';
        if(typeof postData == 'undefined'){
            postData = {};
        }
        postData['requestedFilename'] = requestedFilename;
        postData['cookie'] = cookie;

        $.ajax({
            method: "POST",
            url: formURL,
            data: postData,
            dataType: 'JSON'
        })
            .done(function( resp ) {
                if(resp.success){
                    if(resp.state == 'collect_data'){
                        var modalBody = $( userDataModal.find('.modal-body')[0] );
                        modalBody.html( resp.form );
                        addFormHandler(downloadURL, requestedFilename);
                        userDataModal.modal('show');
                    }else if(resp.state == 'data_on_file'){
                        userDataModal.modal('hide');
                        Cookies.set('robinson_fans_download_cookie', resp.data);
                        window.location = downloadURL;
                    }else{
                        console.log('unexpected response', resp);
                    }
                }else{
                    console.log('Some error happened?', resp);

                    // put the form handlers back on error
                    addFormHandler(downloadURL, requestedFilename);
                    if(resp.state == "form_error"){
                        var field = null;
                        $('.has-error').removeClass('has-error');
                        for(var i in resp.errors){
                            field = $('#' + i);
                            if(field){
                                field.parent('.form-group').addClass('has-error');
                            }
                        }
                    }
                }
            })
            .error(function(e){
                console.log('error!', e);
                addFormHandler(downloadURL, requestedFilename);
            });
    }
    function addFormHandler(downloadURL, requestedFilename){
        var newForm = $("#user-data-form");
        //$('requested_file').val(downloadURL);
        newForm.on('submit',function(e)
        {
            // get the form data
            var innerPostData = $(this).serializeArray();
            // add the requested file name
            innerPostData.push({
                name: 'requestedFilename',
                value: requestedFilename
            });
            e.preventDefault(); //STOP default action
            newForm.off(); //unbind. to stop multiple form submit.
            var cookie = Cookies.get('robinson_fans_download_cookie');
            ajaxCallUserData(downloadURL, requestedFilename, cookie, innerPostData);
        });

    };


});